import * as React from "react";

const GeminiIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M17 23H7a3.003 3.003 0 0 1-3-3v-1.528a2.98 2.98 0 0 1 1.146-2.359l3.236-2.542a1 1 0 0 1 1.236 1.572l-3.236 2.543a1 1 0 0 0-.382.786V20a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1.528a1 1 0 0 0-.382-.786L5.147 7.887A2.98 2.98 0 0 1 4 5.527V4a3.003 3.003 0 0 1 3-3h10a3.003 3.003 0 0 1 3 3v1.528a2.98 2.98 0 0 1-1.146 2.359l-3.236 2.542a1 1 0 1 1-1.236-1.573l3.236-2.542A1 1 0 0 0 18 5.528V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1.528a1 1 0 0 0 .382.786l12.472 9.8A2.98 2.98 0 0 1 20 18.471V20a3.003 3.003 0 0 1-3 3"
    ></path>
  </svg>
);

export default GeminiIcon;
